/**
 * 模块名称: 合同列表 => 修改运营属性弹窗
 */
import React, { useRef, useState, useEffect } from 'react'
import {
  Form,
  Input,
  Select,
  message,
  Icon,
  Button,
  Upload,
  Drawer,
  Spin,
} from 'antd'
import api from '@/api'
import { upLoadModule } from '@/utils/common'

const { Dragger } = Upload
const FormItem = Form.Item
const Option = Select.Option

const operationalList = [
  { value: 1, label: '直销代运营' },
  { value: 2, label: '直销自运营' },
  { value: 3, label: '渠道代运营' },
  { value: 4, label: '渠道自运营' }
]

const OperationalChangeDrawer = (props) => {
  const {
    operationalVisible,
    setOperationalVisible,
    getList,
    addType,
    editId,
    operationalData,
    titleName = '运营属性修改申请',
    history,
    form
  } = props
  const { getFieldDecorator, validateFields, setFieldsValue, resetFields } = form

  const [saveLoading, setSaveLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const draggerRef = useRef(null)
  const [formLoading, setFormLoading] = useState(false)
  const [filteredOperationalList, setFilteredOperationalList] = useState(operationalList)
  const [detailData, setDetailData] = useState(null)

  useEffect(() => {
    if (operationalVisible) onEdit()
  }, [operationalVisible])

  const getSelectData = (clientSource) => {
    return new Promise((resolve) => {
      if (clientSource === 0) {
        setFilteredOperationalList(operationalList.filter(v => v.value === 1 || v.value === 2))
      } else if (clientSource === 1) {
        setFilteredOperationalList(operationalList.filter(v => v.value === 3 || v.value === 4))
      } else {
        setFilteredOperationalList(operationalList)
      }
      resolve()
    })
  }

  const onEdit = () => {
    resetFields()

    if (addType === 0) {
      getSelectData(operationalData?.clientSource)
    } else if (addType === 1) {
      setFormLoading(true)
      api.getOperationalAttrChangeDetail({ id: editId }).then(res => {
        setFormLoading(false)
        setDetailData(res)
        const { clientSource, newOperationalAttributes, oNote, oFiles } = res

        getSelectData(clientSource).then(() => {
          setFieldsValue({
            operationalAttributes: newOperationalAttributes,
            note: oNote
          })
        })
        const oFilesList = JSON.parse(oFiles)
        if (oFilesList) {
          oFilesList.forEach((item, index) => {
            fileList.push({
              status: 'done',
              uid: index,
              name: item.name,
              url: item.url
            })
          })
          setFileList(oFilesList.map((item, i) => ({ ...item, uid: i })))
        } else {
          setFileList([])
        }
      }).catch(() => {
        setFormLoading(false)
      })
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    validateFields((err, vals) => {
      if (!err) {
        const currentAttr = addType === 1
          ? detailData?.oldOperationalAttributes
          : operationalData?.operationalAttributes

        if (currentAttr === vals.operationalAttributes) {
          return message.warning('当前运营属性与变更运营属性不能相同！')
        }

        if (!fileList.length) {
          return message.warning('请上传附件')
        }

        const uploadList = []
        for (let i = 0, k = fileList.length; i < k; i++) {
          if (fileList[i].status !== 'removed') {
            uploadList.push({
              url: fileList[i].url,
              name: fileList[i].name
            })
          }
        }
        setSaveLoading(true)
        const params = {
          ...vals,
          id: addType === 1 ? editId : operationalData.id,
          files: JSON.stringify(uploadList)
        }

        const apiCall = addType === 1
          ? api.getOperationalAttrChangeReApply
          : api.getOperationalAttrChangeApply

        apiCall(params)
          .then(() => {
            message.success(addType === 1 ? '重新申请成功' : '申请成功')
            setOperationalVisible(false)
            if (addType === 1) {
              getList()
            } else {
              history.push('/protocol/operationalChange')
            }
          })
          .catch(() => setSaveLoading(false))
      }
    })
  }

  const uploadFiles = upLoadModule({
    fileList: fileList,
    setFileList: setFileList,
    draggerRef: draggerRef,
    allowSizeType: 3,
    limitNum: 1
  })

  const formItemLayout = {
    labelCol: { xs: { span: 24 }, sm: { span: 6 } },
    wrapperCol: { xs: { span: 24 }, sm: { span: 16 } }
  }

  const handleClose = () => {
    setOperationalVisible(false)
    resetFields()
    setFileList([])
  }

  // 获取当前显示的数据
  const getDisplayData = (field) => {
    return addType === 1 ? detailData?.[field] : operationalData?.[field]
  }

  return (
    <Drawer
      title={titleName}
      width={700}
      visible={operationalVisible}
      onClose={handleClose}
      destroyOnClose={true}
    >
      <Spin spinning={formLoading}>
        <Form onSubmit={formSubmit} {...formItemLayout}>
          <FormItem label="客户名称/代理商名称">
            <span>{getDisplayData('customerName') || '-'}</span>
          </FormItem>
          <FormItem label="OAID/QID">
            <span>{getDisplayData('customerId') !== 0 ? getDisplayData('customerId') : '-'}</span>
          </FormItem>
          <FormItem label="合同主体">
            <span>{getDisplayData('accountName') || '-'}</span>
          </FormItem>
          <FormItem label="合同模板">
            <span>{getDisplayData('templateTypeName') || '-'}</span>
          </FormItem>
          <FormItem label="合同编号">
            <span>{getDisplayData('contractNo') || '-'}</span>
          </FormItem>
          <FormItem label="合同当前运营属性">
            <span>
              {addType === 1
                ? detailData?.oldOperationalAttributesName
                : operationalData?.operationalAttributesName || '-'}
            </span>
          </FormItem>
          <FormItem label="合同变更运营属性">
            {getFieldDecorator('operationalAttributes', {
              rules: [{ required: true, message: '请选择运营属性' }]
            })(
              <Select placeholder="请选择运营属性">
                {filteredOperationalList.map(item => (
                  <Option key={item.value} value={item.value}>{item.label}</Option>
                ))}
              </Select>
            )}
          </FormItem>
          <FormItem label="备注">
            {getFieldDecorator('note')(
              <Input.TextArea placeholder="请输入备注" />
            )}
          </FormItem>
          <FormItem label={<><span style={{ color: 'red' }}>*</span>上传附件</>}>
            <div ref={draggerRef} style={{ position: 'relative' }}>
              <Dragger {...uploadFiles}>
                <p className='ant-upload-drag-icon'><Icon type='inbox' /></p>
                <p className='ant-upload-text'>点击或将文件拖拽到这里上传</p>
                <p className='ant-upload-hint'>支持扩展名：PDF、JPG、PNG等 文件大小不超过10M。一次只能上传一个附件。</p>
              </Dragger>
            </div>
          </FormItem>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
            <Button onClick={() => handleClose()}>取消</Button>
            <Button loading={saveLoading} type="primary" htmlType="submit" style={{ marginLeft: 30 }}>
              {addType === 1 ? '确认' : '申请'}
            </Button>
          </div>
        </Form>
      </Spin>
    </Drawer>
  )
}

export default Form.create()(OperationalChangeDrawer)